<section>
  <div class="relative h-[400px] z-10 bg-[url('/images/feedback.png')] bg-cover bg-center mt-[-6.6875rem]">
    <div class="absolute inset-0 bg-white/60"></div>
    <div class="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3">
      <h4 class="text-secondary text-4xl font-bold">
        {{ "Feedback.Title" | translate }}
      </h4>
      <h4 class="text-[#6B7280] dark:text-[#F2F2F2] mt-2 font-bold">
        {{ "Feedback.SubTitle" | translate }}
      </h4>
    </div>
  </div>
  <div class="feedback py-10 flex flex-col gap-4 container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <h3 class="bg-[#EFF5FD] text-brand rounded px-2 py-1 text-sm font-medium mx-auto text-center w-fit">
      {{ "Feedback.State_Header" | translate }}
    </h3>
    <h3 class="text-4xl font-medium text-center">
      {{ "Feedback.State_Title" | translate }}
    </h3>
    <h3 class="text-base text-[#6B7280] text-center font-medium">
      {{ "Feedback.State_SubTitle" | translate }}
    </h3>
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
      @for (stat of stats; track stat.label) {
      <div class="bg-[#F7F8FA] border border-[#E5E7EB] rounded-2xl p-6 text-center">
        <h3 class="font-bold text-primary mb-2 text-4xl">
          {{ stat.value }}
        </h3>

        <p class="text-xs uppercase text-gray-500">
          {{ stat.label | translate }}
        </p>
      </div>
      }
    </div>

    <!-- <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
      @for (review of reviews; track review.name) {
      <div class="border border-[#E5E7EB] rounded-3xl p-6 bg-white">
        <div class="text-3xl text-gray-400 mb-4">
          <i class="fa-solid fa-quote-left"></i>
        </div>

        <p class="text-sm text-[#6B7280] leading-7 mb-6">
          {{ review.review | translate }}
        </p>

        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-sm"
          >
            {{ review.avatar }}
          </div>

          <div>
            <h4 class="font-medium text-sm">
              {{ review.name }}
            </h4>

            <p class="text-xs text-gray-500">
              {{ review.location }}
            </p>
          </div>
        </div>
      </div>
      }
    </div> -->
    <div class="flex flex-col gap-2 bg-light-blue rounded-lg px-4 py-4">
      <h4 class="text-2xl text-center dark:text-[#F2F2F2] font-bold">
        {{ "Feedback.Option_Title" | translate }}
      </h4>
      <h4 class="text-center text-[#6B7280] font-medium">
        {{ "Feedback.Option_SubTitle" | translate }}
      </h4>

      <form class="pt-4" [formGroup]="feedbackForm">
        <div class="flex flex-col gap-2">
          <!-- emoji -->
          <div class="flex gap-0 md:gap-2 justify-center items-end mt-4 mx-3">
            <!-- Very Bad -->
            <label class="flex flex-col items-center gap-3 group cursor-pointer min-w-[64px] md:min-w-[80px]">
              <input type="radio" formControlName="emojiType" value="VERY_BAD" class="peer hidden" />
              <div
                class="relative w-12 h-12 md:w-16 md:h-16 transition-transform duration-100 group-hover:scale-125 peer-checked:scale-125 peer-checked:[&_img:first-child]:opacity-0 peer-checked:[&_img:last-child]:opacity-100">
                <img class="absolute inset-0 w-full h-full transition-opacity duration-100 group-hover:opacity-0"
                  src="/icons/Angry- Very Bad.svg" alt="" />
                <img
                  class="absolute inset-0 w-full h-full transition-opacity duration-100 opacity-0 group-hover:opacity-100"
                  src="/icons/veryBadHover.svg" alt="" />
              </div>
              <span
                class="text-xs md:text-sm font-medium text-dark-gray transition-colors duration-100 group-hover:text-secondary peer-checked:text-secondary whitespace-nowrap">{{
                "Feedback.Very_Bad" | translate }}</span>
            </label>

            <!-- Sad -->
            <label class="flex flex-col items-center gap-3 group cursor-pointer min-w-[64px] md:min-w-[80px]">
              <input type="radio" formControlName="emojiType" value="BAD" class="peer hidden" />
              <div
                class="relative w-12 h-12 md:w-16 md:h-16 transition-transform duration-100 group-hover:scale-125 peer-checked:scale-125 peer-checked:[&_img:first-child]:opacity-0 peer-checked:[&_img:last-child]:opacity-100">
                <img class="absolute inset-0 w-full h-full transition-opacity duration-100 group-hover:opacity-0"
                  src="/icons/Sad.svg" alt="" />
                <img
                  class="absolute inset-0 w-full h-full transition-opacity duration-100 opacity-0 group-hover:opacity-100"
                  src="/icons/sadHoverOrange.svg" alt="" />
              </div>
              <span
                class="text-xs md:text-sm font-medium text-dark-gray transition-all duration-100 opacity-0 group-hover:opacity-100 peer-checked:opacity-100 group-hover:text-secondary peer-checked:text-secondary whitespace-nowrap">{{
                "Feedback.Bad" | translate }}</span>
            </label>

            <!-- Smile -->
            <label class="flex flex-col items-center gap-3 group cursor-pointer min-w-[64px] md:min-w-[80px]">
              <input type="radio" formControlName="emojiType" value="SATISFIED" class="peer hidden" />
              <div
                class="relative w-12 h-12 md:w-16 md:h-16 transition-transform duration-100 group-hover:scale-125 peer-checked:scale-125 peer-checked:[&_img:first-child]:opacity-0 peer-checked:[&_img:last-child]:opacity-100">
                <img class="absolute inset-0 w-full h-full transition-opacity duration-100 group-hover:opacity-0"
                  src="/icons/Smile.svg" alt="" />
                <img
                  class="absolute inset-0 w-full h-full transition-opacity duration-100 opacity-0 group-hover:opacity-100"
                  src="/icons/smileHoverYellow.svg" alt="" />
              </div>
              <span
                class="text-xs md:text-sm font-medium text-dark-gray transition-all duration-100 opacity-0 group-hover:opacity-100 peer-checked:opacity-100 group-hover:text-secondary peer-checked:text-secondary whitespace-nowrap">{{
                "Feedback.Satisfied" | translate }}</span>
            </label>

            <!-- Happy -->
            <label class="flex flex-col items-center gap-3 group cursor-pointer min-w-[64px] md:min-w-[80px]">
              <input type="radio" formControlName="emojiType" value="GOOD" class="peer hidden" />
              <div
                class="relative w-12 h-12 md:w-16 md:h-16 transition-transform duration-100 group-hover:scale-125 peer-checked:scale-125 peer-checked:[&_img:first-child]:opacity-0 peer-checked:[&_img:last-child]:opacity-100">
                <img class="absolute inset-0 w-full h-full transition-opacity duration-100 group-hover:opacity-0"
                  src="/icons/Happy.svg" alt="" />
                <img
                  class="absolute inset-0 w-full h-full transition-opacity duration-100 opacity-0 group-hover:opacity-100"
                  src="/icons/happyHovergreen.svg" alt="" />
              </div>
              <span
                class="text-xs md:text-sm font-medium text-dark-gray transition-all duration-100 opacity-0 group-hover:opacity-100 peer-checked:opacity-100 group-hover:text-secondary peer-checked:text-secondary whitespace-nowrap">{{
                "Feedback.Good" | translate }}</span>
            </label>

            <!-- Very Good -->
            <label class="flex flex-col items-center gap-3 group cursor-pointer min-w-[64px] md:min-w-[80px]">
              <input type="radio" formControlName="emojiType" value="VERY_GOOD" class="peer hidden" />
              <div
                class="relative w-12 h-12 md:w-16 md:h-16 transition-transform duration-100 group-hover:scale-125 peer-checked:scale-125 flex items-center justify-center peer-checked:[&_img:first-child]:opacity-0 peer-checked:[&_img:last-child]:opacity-100">
                <img class="absolute w-[92%] h-[92%] transition-opacity duration-100 group-hover:opacity-0"
                  src="/icons/lOVE.svg" alt="" />
                <img class="absolute w-[92%] h-[92%] transition-opacity duration-100 opacity-0 group-hover:opacity-100"
                  src="/icons/loveHoverSucess.svg" alt="" />
              </div>
              <span
                class="text-xs md:text-sm font-medium text-dark-gray transition-colors duration-100 group-hover:text-secondary peer-checked:text-secondary whitespace-nowrap">{{
                "Feedback.Very_Good" | translate }}</span>
            </label>
          </div>
          @if (isSubmitted && getControl('emojiType').invalid) {
          <div class="text-danger text-center mt-2">
            <small>Please select a rating</small>
          </div>
          }

          <div class="bg-white rounded-lg px-4 py-4 mt-1">
            <!-- buttons -->
            <div class="flex flex-col gap-4 mb-8">
              <h3 class="font-medium">
                {{ "Feedback.Lets_Know" | translate }}
              </h3>

              <div class="flex flex-wrap gap-2 md:gap-3">
                @for (option of options; track $index) {
                <button type="button" (click)="toggleSubject(option.value)" [ngClass]="{
                    'bg-gray-shade border-brand text-brand':
                      getControl('emailSubject').value === option.value,
                    'bg-transparent border-gray-200 text-black':
                      getControl('emailSubject').value !== option.value
                  }" class="px-5 py-2.5 rounded-lg border transition-all duration-300 text-sm font-semibold">
                  {{ option.key | translate }}
                </button>
                }
              </div>
              @if (isSubmitted && getControl('emailSubject').invalid) {
              <div class="text-danger mt-2">
                <small>Please select a feedback category</small>
              </div>
              }
            </div>
            <div class="flex flex-col md:flex-row gap-4 justify-between w-full mt-6">
              <!-- data -->
              <div class="w-full md:w-[50%]">
                <label class="text-muted font-medium dark:text-[#A5A6A8]" for="firstname">
                  {{ "Shared.First_Name" | translate }}
                </label>
                <input type="text" id="firstname" class="shared-input dark:text-white dark:bg-primary-dark" [ngClass]="{
                    'is-invalid':
                      isSubmitted && getControl('senderFirstName').invalid,
                    'is-valid':
                      isSubmitted && getControl('senderFirstName').valid
                  }" placeholder="{{
                    'Shared.First_Name_Placeholder' | translate
                  }} " formControlName="senderFirstName" />

                @if(isSubmitted && getControl('senderFirstName').invalid){
                <div class="text-danger mt-1">
                  @if (getControl('senderFirstName').errors?.['pattern']) {
                  <small>{{ "Errors.Name_Error" | translate }}</small>
                  }
                </div>
                }
              </div>
              <div class="w-full md:w-[50%]">
                <label class="text-muted font-medium dark:text-[#A5A6A8]" for="lastname">
                  {{ "Shared.Last_Name" | translate }}
                </label>
                <input type="text" id="lastname" class="shared-input dark:text-white dark:bg-primary-dark" [ngClass]="{
                    'is-invalid':
                      isSubmitted && getControl('senderLastName').invalid,
                    'is-valid':
                      isSubmitted && getControl('senderLastName').valid
                  }" placeholder=" {{
                    'Shared.Last_Name_Placeholder' | translate
                  }} 
                             " formControlName="senderLastName" />
                @if(isSubmitted && getControl('senderLastName').invalid){
                <div class="text-danger mt-1">
                  @if (getControl('senderLastName').errors?.['pattern']) {
                  <small>{{ "Errors.Name_Error" | translate }}</small>
                  }
                </div>
                }
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-4 justify-between w-full mt-3">
              <div class="w-full md:w-[50%]">
                <label class="text-muted font-medium dark:text-[#A5A6A8]" for="email">
                  {{ "Shared.Email" | translate }}
                </label>
                <input type="text" id="email" class="shared-input dark:text-white dark:bg-primary-dark" [ngClass]="{
                    'is-invalid':
                      isSubmitted && getControl('senderEmail').invalid,
                    'is-valid': isSubmitted && getControl('senderEmail').valid
                  }" placeholder=" {{
                    'Shared.Email_Placeholder' | translate
                  }}              " formControlName="senderEmail" />
                @if(isSubmitted && getControl('senderEmail').invalid){
                <div class="text-danger mt-1">
                  @if (getControl('senderEmail').errors?.['pattern']) {
                  <small>{{ "Errors.Email_Error" | translate }}</small>
                  }
                </div>
                }
              </div>
              <div class="w-full md:w-[50%]">
                <label class="text-muted font-medium dark:text-[#A5A6A8]" for="mobilePhone">
                  {{ "Shared.Phone" | translate }}
                </label>
                <ngx-intl-tel-input inputId="mobilePhone" [cssClass]="
                    'shared-input mt-2 dark:bg-second-dark dark:border-border-dark w-full'
                  " #phoneInput [preferredCountries]="[]" [selectedCountryISO]="CountryISO.Italy"
                  [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                  [searchCountryField]="[
                    SearchCountryField.Name,
                    SearchCountryField.DialCode
                  ]" [separateDialCode]="true" formControlName="mobilePhone"></ngx-intl-tel-input>
                @if ( isSubmitted && getControl('mobilePhone'
                ).hasError('validatePhoneNumber') ) {
                <small class="text-[#dc3545] font-medium">
                  {{ "Errors.Number_Error" | translate }}
                </small>
                }
              </div>
            </div>

            <div class="flex flex-col gap-4 justify-between w-full mt-3">
              <label class="text-muted font-medium dark:text-[#A5A6A8]" for="message">{{ "Contact.Message" | translate
                }}
              </label>
              <textarea rows="5" name="" id="message" class="shared-input dark:text-white dark:bg-primary-dark mb-0"
                [ngClass]="{
                  'is-invalid': isSubmitted && getControl('emailBody').invalid,
                  'is-valid': isSubmitted && getControl('emailBody').valid
                }" placeholder="{{ 'Contact.Message' | translate }} " formControlName="emailBody"></textarea>
              @if(isSubmitted && getControl('emailBody').invalid){
              <div class="text-danger mt-1">
                @if (getControl('emailBody').errors?.['minlength']) {
                <small>{{ "Errors.Minlength_Error" | translate }}</small>
                }
              </div>
              }
            </div>
            <div class="flex justify-end mt-2">
              <div class="w-full lg:w-[30%] flex gap-4">
                <button type="button" class="btn-submit py-2 bg-white text-[#6B7280] px-3 border-1 border-[#eaeaea]"
                  (click)="resetForm()">
                  {{ "Feedback.Clear" | translate }}
                </button>
                <button type="button" class="btn-submit py-2" (click)="onSubmit()">
                  {{ "Feedback.Send" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

@if(showConfirmationModal) {
<app-confirm-feedback [isHappy]="isHappy" [rating]="rating" (continue)="confirmForm()" (close)="closeModal()" />
}